import React, { useEffect, useState, useRef } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import axiosInstance from "../Axios/AxiosInstance";
import ReusableTable from "../Components/Table/ReusableTable";
import { MdDownload, MdOutlineUpload, MdClose, MdCalendarViewDay, MdCalendarToday, MdCloudUpload, MdFilterAltOff } from "react-icons/md";
import DatePicker from "../Components/DatePicker/DatePicker";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BsCalendar3 } from "react-icons/bs";

const ScannedFileUpload = () => {
  const [scannedQrData, setscannedQrData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDates, setSelectedDates] = useState({ startDate: '', endDate: '' });
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);


  const pageDataRef = useRef({});
  const fileInputRef = useRef(null);
  const popupRef = useRef(null);

  const userinfo = JSON.parse(sessionStorage.getItem('userinfo')) || {};
  const userName = userinfo.employeeName || 'Guest';
  const userRole = userinfo.rolename || 'Unknown';
  const employeeId = userinfo.employeeId || 'N/A';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowDatePicker(false)
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const formatDate = (date) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  };

  const formatDateDisplay = (date) => {
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    fetchQrScannedData();
  }, [currentPage, rowsPerPage, searchInput, selectedDates]);


  const fetchQrScannedData = () => {
    const cacheKey = `${currentPage}-${rowsPerPage}-${selectedDates.startDate || ""}-${selectedDates.endDate || ""}-${searchInput}`;

    if (pageDataRef.current[cacheKey]) {
      setscannedQrData(pageDataRef.current[cacheKey]);
      setIsLoading(false);
    } else {
      setIsLoading(true);

      axiosInstance
        .post("/admindashboard/ScannedQRFileList", {
          fromDate: selectedDates.startDate,
          toDate: selectedDates.endDate,
          dealerId: 0,
          painterId: 0,
          pageNumber: currentPage,
          pageSize: rowsPerPage,
          searchItem: searchInput || "",
        })
        .then((response) => {
          const { scannedQrCodeList, paginatedData } = response.data;

          const updatedscannedQrCodeList = scannedQrCodeList.map((order) => {
            const dateObj = new Date(order.uploadedDate);
            const day = String(dateObj.getDate()).padStart(2, "0");
            const month = String(dateObj.getMonth() + 1).padStart(2, "0");
            const year = dateObj.getFullYear();
            return {
              ...order,
              uploadedDate: `${day}/${month}/${year}`,
            };
          });

          setscannedQrData(updatedscannedQrCodeList);
          setTotalRecords(paginatedData.totalRecords);
          // pageDataRef.current[cacheKey] = updatedscannedQrCodeList;
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error fetching order data:", error);
        });
    }
  };


  const clearFilters = () => {
    setSelectedDates({ startDate: '', endDate: '' });
    setSearchInput('');
  };

  const columns = [
    { key: "fileName", label: "Name" },
    { key: "uploadedDate", label: "Uploaded Date" },
    { key: "createdBy", label: "Uploaded By" },
  ];

  const handleSelectedRowsChange = (newSelectedRows) => {
    setSelectedRows(newSelectedRows);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = Number(event.target.value);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const handleDateSubmit = (dates) => {
    const formattedDates = {
      startDate: formatDate(dates.startDate),
      endDate: formatDate(dates.endDate),
    };
    setSelectedDates(formattedDates);
    setShowDatePicker(false);
  };

  const handleDownloadClick = (row) => {
    const { id } = row;

    axiosInstance
      .get("/admindashboard/ScannedQRFileDownload", {
        params: { fileId: id },
      })
      .then((response) => {
        const { fileName, fileType, fileData } = response.data;

        if (fileName && fileType && fileData) {
          const byteCharacters = atob(fileData);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/vnd.ms-excel" });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", `${fileName}${fileType}`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          toast.error("File data is missing in the response.");
        }
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
        toast.error("Failed to download file. Please try again.");
      });
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUploadClick = async () => {
    if (!selectedFile) {
      toast.error("Please select a file first.");
      return;
    }
    const formData = new FormData();
    formData.append("UpdFileName", selectedFile);
    formData.append("CreatedBy", employeeId);
    try {
      await axiosInstance.post("/admindashboard/ScannedQRFileUpload", formData, {
        headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },
      });
      toast.success("File uploaded successfully!");
      setShowUploadModal(false);
      setSelectedFile(null);
      pageDataRef.current = {};
      fetchQrScannedData();
    } catch (error) {
      const errorMessage = error.response?.data?.value || "File upload failed!";
      toast.error(errorMessage);
    }
  };

  const handleCloseModal = () => {
    setSelectedFile(null);
    setShowUploadModal(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    const allowedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv"
    ];
    if (file && allowedTypes.includes(file.type)) {
      setSelectedFile(file);
    } else {
      alert("Invalid file type. Please upload an Excel (.xls, .xlsx) or CSV (.csv) file.");
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header title={"Scanned Files"} />
      <div className="flex flex-col flex-1 mx-2 my-2">

        <div className="flex flex-wrap justify-between items-center mt-2 mb-1">
          <div className="flex items-center gap-4 ml-1">
            {selectedDates.startDate && (
              <div className="ml-2 flex space-x-3">
                <span className="bg-[#1e365e] text-white px-3 py-2 rounded-lg shadow-md">
                  From: {formatDateDisplay(selectedDates.startDate)}
                </span>
                <span className="bg-[#1e365e] text-white px-4 py-2 rounded-lg shadow-md ">
                  To: {formatDateDisplay(selectedDates.endDate)}
                </span>
              </div>
            )}
          </div>
          <div className="flex items-center gap-3 mr-2">
            <span
              className="text-[#1e365e] cursor-pointer hover:text-[#1e365e]  "
              onClick={clearFilters}
              title="Clear Filter"
            >
              <MdFilterAltOff size={32} />
            </span>
            <span
              className="text-[#1e365e] cursor-pointer hover:text-[#1e365e]  "
              onClick={() => setShowDatePicker(!showDatePicker)}
              title="Date Filter"
            >
              <BsCalendar3 size={25} />
            </span>
            <span
              className="text-3xl text-[#1e365e] cursor-pointer hover:text-[#1e365e]"
              onClick={() => setShowUploadModal(true)}
              title="Upload"
            >
              <MdCloudUpload size={35} />
            </span>
          </div>
        </div>
        <div className="mt-1 p-1">
          <ReusableTable
            data={scannedQrData}
            columns={columns}
            rowsPerPage={rowsPerPage}
            loading={isLoading}
            currentPage={currentPage}
            totalRecords={totalRecords}
            enableDownload={true}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onSelectedRowsChange={handleSelectedRowsChange}
            onDownloadClick={handleDownloadClick}
          />
        </div>
        {showDatePicker && (
          <dialog open
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              border: "none",
              background: "none",
              maxHeight: "70vh",
              overflowY: "auto",
            }}
            ref={popupRef}>
            <div >
              <DatePicker onCancel={() => setShowDatePicker(false)} onSubmit={handleDateSubmit} />
            </div>
          </dialog>
        )}
        {showUploadModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold">Upload File</h2>
                <button onClick={handleCloseModal}>
                  <MdClose size={24} />
                </button>
              </div>

              <div
                className="border-2 border-dashed border-gray-400 rounded-lg p-6 flex flex-col items-center justify-center cursor-pointer hover:border-blue-900"
                onClick={() => fileInputRef.current.click()}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
              >
                <p className="text-gray-600">Drag & Drop file here or click to select</p>
                <input
                  type="file"
                  accept=".xls,.csv"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                />
              </div>
              {selectedFile && <p className="text-gray-700 mt-3 text-center">📂 {selectedFile.name}</p>}
              <div className="flex justify-end gap-2 mt-4">
                <button className="bg-gray-500 text-white px-4 py-2 rounded" onClick={handleCloseModal}>
                  Cancel
                </button>
                <button className="bg-[#1e365e] text-white px-4 py-2 rounded" onClick={handleUploadClick}>
                  Upload
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
      <Footer />
      <ToastContainer />
    </div>
  );
};

export default ScannedFileUpload;
